import axios from 'axios';
import { createAsyncThunk } from 'app/store/utils';
import { Settings } from 'types/general.types';
import { FetchSettingsResponse } from 'types/api.types';
import { apiUrls } from 'app/api.config';

export const fetchSettingsEffect = createAsyncThunk(
  'settings/fetch',
  async () => {
    const { data } = await axios.get<FetchSettingsResponse>(apiUrls.settings);
    return data;
  }
);

export const updateBadgeVisibleEffect = createAsyncThunk(
  'settings/updateBadgeVisible',
  async (data: { visible: boolean }, { getState }) => {
    const { settings } = getState().settings;
    const badgeData: Settings = {
      ...settings,
      badge: { ...settings.badge, visible: data.visible },
    };
    await axios.put(apiUrls.settings, badgeData);
  }
);
